import Urls from "@/common/urls";
import Apiroot from "@/common/apiroot";
import axios from "axios";

const devStore = {
  state: {
    reMenu: 0,
    lineIndex : 0,
    urlType: null,
    params: null,
    result: null,

    paramMap: [],
    headerMap: [],
    bodyMap: [],

    title: null,

    appCode: null,
    appData: null,
    apiCode: null,

    apiAuth: [],
    apiTrig: [],
    apiAct: [],

    apiSchema: null, //데이터 1줄씩 하는 애

    apiData: null,
    formsData: null,
    configureData: null,
    testData: null,
    defineData: null,

    lineGroup: { keys: null, label: null },
    lineItem: [],

    requestType : "form-data",
    rawTypedData : "{}",
  },
  getters: {
    getAppCode(state) {
      return state.appCode;
    },
    getApiCode(state) {
      return state.apiCode;
    },
    getAppData(state) {
      return state.appData;
    },
    getConfigData(state) {
      return state.configureData;
    },
    getAuthApiData(state){
      return state.apiAuth;

    },
    getTrigApiData(state){
      return state.apiTrig;

    },
    getActApiData(state){
      return state.apiAct;

    }
  },
  mutations: {
    urlChecking(state, { address }) {
      console.log("mutation", this.address);
      state.address = address;
    },
    emptyParams(state) {
      state.params = null;
    },
    setApiArrays(state, { auth, trig, act }) {
      state.apiAuth = auth;
      state.apiTrig = trig;
      state.apiAct = act;
      console.log("여기 : ", state.apiAuth, state.apiTrig, state.apiAct);
    },
    resetApiArrays(state) {
      state.apiAuth = null;
      state.apiTrig = null;
      state.apiAct = null;
    },
    emptyMenu(state) {
      state.reMenu = 0;
    },
    insertData(
      state,
      { apiData, formsData, configureData, testData, defineData }
    ) {
      state.apiData = apiData;
      state.formsData = formsData;
      state.configureData = configureData;
      state.testData = testData;
      state.defineData = defineData;
    },
    setRequestBody(state, { bodyData }) {
      state.configureData[0].requestBody = bodyData;

      console.log(bodyData);
      console.log(state.configureData[0].requestBody);
    },
    setApiDatas(state, { auth, trig, act }) {
      console.log(auth, trig, act)
        state.apiAuth = auth;
        state.apiTrig = trig;
        state.apiAct = act;


    },
  },
  actions: {
    setApiDataAll({commit}, { auth, trig, act }){
      console.log("스토어 진입 ")
      commit('setApiDatas', {auth, trig, act })
    },
    async submitData({ commit }, { paths, params }) {
      console.log(commit);
      console.log(paths);
      console.log(params);
      const result = await axios.post(paths, params, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (result.status == 200) {
        if (result.data["code"] == 0) {
          return result.data;
        }
      }
      commit("emptyParams");
    },

    async apiSetting({ commit }) {
      var authList = [];
      var trigList = [];
      var actList = [];

      console.log(this.getters.getAppCode);
      console.log("버전코드:", this.getters.getAppData.versionCode);
      console.log(commit);

      const result = await axios.post(
        Apiroot.api + Urls.selectApi,
        {
          appCode: this.getters.getAppCode,
          versionCode: this.getters.getAppData.versionCode,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (result.status == 200) {
        if (result.data["code"] == 0) {
          const api = result.data["api"];
          console.log("api : ", api);

          if (api != null) {
            for (var i = 0; i < api.length; i++) {
              console.log(api[i]);
              if (api[i].apiType != "trigger" && api[i].apiType != "action") {
                authList.push(api[i]);
              } else if (api[i].apiType == "trigger") {
                trigList.push(api[i]);
              } else if (api[i].apiType == "action") {
                actList.push(api[i]);
              }
            }
          }

          commit("setApiArrays", {
            auth: authList,
            trig: trigList,
            act: actList,
          });
          commit("emptyMenu");
          // return result
        }
      }
    },
    async apiDetail({ commit }, {result}) {
      // this.api.selectApiSchema({
      //   apiCode: this.getters.getApiCode,
      // })
      //     .then((result)=>{

          console.log("결과값 stroe",result)

            // if (result.status == 200) {
              if (result.code == 0) {
                console.log(result);
                const api = result.api;
                const forms = result.forms;
                const configs = result.configs;
                const tests = result.tests;
                const defines = result.defines;
                console.log("api : ", api);
                console.log("forms : ", forms);
                console.log("configs : ", configs);
                console.log("defines : ", defines);

                commit("insertData", {
                  apiData: api,
                  formsData: forms,
                  configureData: configs,
                  testData: tests,
                  defineData: defines,
                });
              }
            // }
          // })


      // const result = await axios.post(
      //   Apiroot.api + Urls.selectApiSchema,
      //   {
      //     apiCode: this.getters.getApiCode,
      //   },
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

    },
    async addRequestBodyWhileAdding({ commit }, { keys, oldText }) {
      var reqBody = this.getters.getConfigData[0].requestBody;

      console.log("오오오오오오!!!  wwww", reqBody);

      var inin2 = new Array();
      if (Object.keys(JSON.parse(reqBody)).length > 0) {
        for (var k = 0; k < Object.keys(JSON.parse(reqBody)).length; k++) {
          console.log("오오오오오오!!! ?", Object.keys(JSON.parse(reqBody))[k]);

          var keyName = Object.keys(JSON.parse(reqBody))[k];

          var data = new Object();

          if (oldText != null && oldText == keyName) {
            console.log("오오오오오오!!! 1", keyName);
            data.keys = keys;

            if (Object.values(JSON.parse(reqBody))[k].includes("{{")) {
              data.values = "{{bundle.inputData." + keys + "}}";
            } else {
              console.log("오오오오오오!!! 2", keyName);
              data.values = Object.values(JSON.parse(reqBody))[k];
            }
          } else {
            console.log("오오오오오오!!! 3", keyName);

            data.keys = Object.keys(JSON.parse(reqBody))[k];
            data.values = Object.values(JSON.parse(reqBody))[k];
          }

          inin2.push(data);
        }
      } else {
        console.log("오오오오오오!!! 4", keyName);
        data = new Object();
        data.keys = keys;
        data.values = "{{bundle.inputData." + keys + "}}";

        inin2.push(data);
      }

      var map = new Map();

      if (inin2.length > 0) {
        for (var i = 0; i < inin2.length; i++) {
          if (
            inin2[i].keys != null &&
            inin2[i].keys != "null" &&
            inin2[i].keys != ""
          ) {
            map.set(inin2[i].keys, inin2[i].values);
          }
        }
      }

      if (oldText == null) {
        if (keys != null && keys != "null" && keys != "") {
          map.set(keys, "{{bundle.inputData." + keys + "}}");
        }
      }

      console.log("와 ??????아 ?????", inin2);
      console.log("와 ??????아 ?????", map);

      // this.$store.state.devStore.configureData[0].requestBody = Object.fromEntries(map)

      commit("setRequestBody", { bodyData: Object.fromEntries(map) });

      console.log("마지막 : ", this.getters.getConfigData);
    },
  },
  watch: {},
  computed: {
    reMenuing() {
      return this.$store.state.devStore.apiAuth;
    },
  },
};

export default devStore;
